import { Component } from '@angular/core';

@Component({
  selector: 'app-gmdashboard-link',
  templateUrl: './gmdashboard-link.component.html',
  styleUrls: ['./gmdashboard-link.component.scss']
})
export class GmdashboardLinkComponent {

}
